/**
 * * Модель для запроса получения информации о проекте
 */
export default class ProjectGetBuIdRequest  {
	/**
	 * * Получить информацыю о проекте по ид проекта
	 */
	ProjectId!: number;
	constructor(obj?: Partial<ProjectGetBuIdRequest>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
